import React from 'react';
import { Typography } from '@mui/material';

interface CustomMapProps {
}

const CustomMap: React.FC<CustomMapProps> = ({ }) => {
    return (
        <>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2872.597598903115!2d17.5534103!3d43.947001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475f0b5b502acb45%3A0x6087d2bda81cf16f!2sMotel%20Radu%C5%A1a!5e0!3m2!1shr!2sba!4v1757024843131!5m2!1shr!2sba"
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius: 8 }}></iframe>
        </>
    )
}

export default CustomMap;